//import { useEffect, useState } from 'react';
//import { useSelector, useDispatch } from 'react-redux';

import AppImages from "../../../assets/AppImages";
import { StyledScrollContainer } from "../../../components/StyledScrollContainer";

// @components
import {
    Avatar,
    Button,
    Typography,
    Card,
    Rating,
} from "@material-tailwind/react";

/*
import {
    listPartsDeliveryRequest,
} from "../redux/parts/actions";
 */


const TABLE_HEAD = [
    "Name",
    "Deal Ratings",
    "Max Buy",
    "Exp Revenue",
    "Auction",
    "Time to Run",
    "Repair Cost",
    "ROI",
    "",
];

interface Bid {
    img: string;
    name: string;
    deal_rating: number;
    max_buy: number;
    revenue: number;
    auction: string;
    time_to_run: string;
    repair_cost: number;
    roi: number;
}

const TABLE_ROW: Bid[] = [];
//@ts-ignore
const TABLE_ROW_: Bid[] = [
    {
        "img": AppImages.bid_1,
        "name": "BMW X4 2024",
        "deal_rating": 4.0,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "Copart",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }, {
        "img": AppImages.bid_2,
        "name": "Radiator Hose",
        "deal_rating": 5.0,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "IAAI",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }, {
        "img": AppImages.bid_3,
        "name": "Clutch Plate",
        "deal_rating": 2.0,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "Copart",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }, {
        "img": AppImages.bid_4,
        "name": "Toyota Camry",
        "deal_rating": 4.5,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "IAAI",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }, {
        "img": AppImages.bid_5,
        "name": "Hyundai Tucson",
        "deal_rating": 4.0,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "Copart",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }, {
        "img": AppImages.bid_1,
        "name": "BMW X4 2024",
        "deal_rating": 4.0,
        "max_buy": 1000,
        "revenue": 20000,
        "auction": "Copart",
        "time_to_run": "4d 3hrs",
        "repair_cost": 1200,
        "roi": 80,
    }
];

export function DashboardTodaysBids() {
    /*
    const dispatch = useDispatch();
    const { deliveries, loading } = useSelector((state: any) => state.parts);

    useEffect(() => {
        //dispatch(listPartsDeliveryRequest({vehicle_fields: 'id,status,display_status,is_listed,ymmt,thumbnail,make,model,vin,inspection_score,inspection_results,parts,tasks,labors,delivery_company,delivery_order,delivery_pickup_date,delivery_est_date,delivery_date,'}));
    }, [dispatch]);
     */

    return (
        <Card>
            <Card.Header className="w-full m-0 items-start rounded-none flex flex-wrap gap-4 justify-between p-4">
                <div>
                    <Typography
                        type="lead"
                        color="default"
                        className="font-semibold mb-1"
                    >
                        Today’s Recommended Bids
                    </Typography>
                    <Typography type="small" className="text-foreground block">
                        Top deals to bid on today.
                    </Typography>
                </div>
                <div className="flex gap-3 items-center sm:w-auto w-full">
                    <Button
                        variant="outline"
                        color="secondary"
                        className="flex items-center shrink-0 gap-2 sm:w-auto w-full"
                    >
                        See All
                    </Button>
                </div>
            </Card.Header>
            <StyledScrollContainer className="max-h-[400px]">
                <Card.Body className="p-0 rounded-none">
                    <table className="w-full min-w-max table-auto text-left">
                        <thead>
                            <tr>
                                {
                                    TABLE_HEAD.map((head) => (
                                        <th key={head} className="border-b border-surface p-4">
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head}
                                            </Typography>
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {TABLE_ROW.map((el, index) => (
                                <tr key={index} className="group">
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <div className="flex items-center gap-3">
                                            <Avatar src={el.img} alt={el.name} shape="rounded" />
                                            <div className="space-y-1">
                                                <Typography
                                                    type="small"
                                                    color="default"
                                                    className="font-semibold block"
                                                >
                                                    {el.name}
                                                </Typography>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <div className="flex flex-wrap items-center gap-2">
                                            <Rating
                                                unratedIcon={<AppImages.starOff />}
                                                ratedIcon={<AppImages.starOn />}
                                                value={Math.round(el.deal_rating)}
                                                className="[&_svg]:size-5 gap-x-1"
                                            />
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="inline-block"
                                            >
                                                {el.deal_rating.toFixed(1)}
                                            </Typography>
                                        </div>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.max_buy.toLocaleString('en-US')}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.revenue.toLocaleString('en-US')}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            {el.auction}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            {el.time_to_run}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.repair_cost.toLocaleString('en-US')}
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Typography type="small" className="block text-foreground">
                                            ${el.roi}%
                                        </Typography>
                                    </td>
                                    <td className="p-4 border-b border-surface group-last:border-none">
                                        <Button size="sm">Bid</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {TABLE_ROW.length == 0 &&
                        <div className="flex flex-col my-20 gap-5 justify-center items-center h-full">
                            <div className="flex bg-secondary items-center p-4 rounded-full">
                                <AppImages.iconTrendUp className="w-6 h-6" />
                            </div>
                            <Typography className="text-primary font-semibold text-2xl">
                                No recommended bids
                            </Typography>
                        </div>
                    }
                </Card.Body>
            </StyledScrollContainer>
        </Card>
    );
}
